// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatusTag_wrapper__TsAQ3","loading":"StatusTag_loading__1PC0f","clickable":"StatusTag_clickable__2NZRS"};